<template>
  <div style="height: 200px;text-align: center;font-size: 30px;">云展台
    
  </div>
</template>

<script>
export default {
  name: "exhibition-cloud",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
</style>
